import { Injectable } from "@angular/core";
import { needsPhoneCompletion } from "../helpers/phone-helper";
import { ForcedPhoneCompletionModalComponent } from "../shared/modals/forced-phone-completion-modal/forced-phone-completion-modal.component";
import { LocalStorageService } from "./localStorage.service";
import {
  ModalQueuePriority,
  ModalQueueService,
} from "./modal-queue.service";

@Injectable({
  providedIn: "root",
})
export class PhoneCompletionGateService {
  private pendingGatePromise: Promise<boolean> | null = null;

  constructor(
    private modalQueue: ModalQueueService,
    private localStorageService: LocalStorageService
  ) {}

  async ensurePhoneCompletionForCurrentUser(): Promise<boolean> {
    const userData = this.localStorageService.getUserData();
    if (!userData?.client || !userData?.token) {
      return true;
    }
    if (!needsPhoneCompletion(userData.client)) {
      return true;
    }
    if (this.pendingGatePromise) {
      return this.pendingGatePromise;
    }

    this.pendingGatePromise = this.openForcedPhoneCompletionModal();
    try {
      return await this.pendingGatePromise;
    } finally {
      this.pendingGatePromise = null;
    }
  }

  private async openForcedPhoneCompletionModal(): Promise<boolean> {
    const dismissed = await this.modalQueue.enqueueModal<{ role?: string }>(
      {
        component: ForcedPhoneCompletionModalComponent,
        cssClass: "phone-completion-modal",
        backdropDismiss: false,
        canDismiss: async (_data, role) => role === "updated",
      },
      {
        id: "phone-completion",
        priority: ModalQueuePriority.CRITICAL,
        waitForSplashEnd: false,
        forcePresent: true,
      }
    );
    return dismissed?.role === "updated";
  }
}
